/** Dev / staging branding (H2BIS). */
export const SLIM_LOGO_DEV = '/logo-slim-h2bis.png';

/** Production branding (live SLIM). */
export const SLIM_LOGO_PROD = '/logo-slim-live.png';

const PROD_ENV_VALUES = new Set(['production', 'prod']);

/**
 * Resolve deployment environment.
 * Build-time VITE_APP_ENV (Docker/CI) takes precedence over runtime window.ENV.
 */
export function getAppEnv() {
  const viteEnv = import.meta.env?.VITE_APP_ENV;
  if (viteEnv) return String(viteEnv).trim().toLowerCase();

  if (typeof window !== 'undefined' && window.ENV?.VITE_APP_ENV) {
    return String(window.ENV.VITE_APP_ENV).trim().toLowerCase();
  }

  if (import.meta.env?.DEV) return 'development';
  return 'production';
}

/** True when the app should use production (live) branding. */
export function isProductionAppEnv() {
  return PROD_ENV_VALUES.has(getAppEnv());
}

/**
 * Public URL path for the SLIM logo appropriate to the current deployment.
 * Dev → logo-slim-h2bis.png · Prod → logo-slim-live.png
 */
export function getSlimLogoPath() {
  return isProductionAppEnv() ? SLIM_LOGO_PROD : SLIM_LOGO_DEV;
}

const APP_TITLE_SUFFIX = 'Enterprice Resource Planning System';

/** Browser tab / document title for the current deployment. */
export function getAppTitle() {
  const prefix = isProductionAppEnv() ? 'SLIM' : 'ZINCAT';
  return `${prefix} - ${APP_TITLE_SUFFIX}`;
}

/** Company name shown on payslips and similar documents. */
export function getCompanyName() {
  return isProductionAppEnv() ? 'SLIM Ltd.' : 'Zincat SLIM Ltd.';
}
